import React from "react";
import { styles } from "../styles/theme";
import PlayerStats from "../components/PlayerStats";
import MiniGames from "../components/minigames/MiniGames";
import AuctionSection from "../components/AuctionSection";
import PollSection from "../components/PollSection";

function GamePage({
  playerData,
  gameData,
  timeLeft,
  canPlay,
  awardMoney,
  bidAmount,
  setBidAmount,
  handleBid,
  topBids,
  handlePollVote,
  isSubmittingVote,
  pollVote,
  statusMsg,
  totalPlayers,
  totalVotes,
  allPlayers,
}) {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Compra el Pan</h1>
        <p style={styles.subtitle}>
          Ronda {gameData.currentRound}/{gameData.totalRounds || 6} · Estado:{" "}
          <strong>{gameData.roundStatus === "open" ? "Jugando" : "Esperando"}</strong>
          <br />
          {gameData.roundStatus === "open" ? (
            <>⏱️ Tiempo restante de ronda: {timeLeft} s</>
          ) : (
            <>⏳ La siguiente ronda inicia en: {timeLeft} s</>
          )}
        </p>

        <PlayerStats playerData={playerData} gameData={gameData} />

        <PollSection
            gameData={gameData}
            playerData={playerData}
            isSubmittingVote={isSubmittingVote}
            handlePollVote={handlePollVote}
            pollVote={pollVote}
            totalPlayers={totalPlayers}
            totalVotes={totalVotes}
        />

        <AuctionSection
          canPlay={canPlay}
          bidAmount={bidAmount}
          setBidAmount={setBidAmount}
          handleBid={handleBid}
          topBids={topBids}
          gameData={gameData}
          totalPlayers={totalPlayers}
          allPlayers={allPlayers}
        />

        {/* Mini-juegos */}
        <section style={{ marginTop: 16 }}>
          <h3 style={styles.sectionTitle}>Mini-juegos</h3>
          {!canPlay && (
            <p style={{ fontSize: 12, color: "#fffbcc" }}>
              La ronda aún no está abierta. Cuando el organizador la abra, podrás jugar para ganar
              dinero.
            </p>
          )}
          <MiniGames 
            canPlay={canPlay} 
            onWinMoney={awardMoney} 
            currentRound={gameData.currentRound}
          />
        </section>

        {statusMsg && (
          <p style={{ marginTop: 12, fontSize: 12, color: "#fffbcc" }}>{statusMsg}</p>
        )}
      </div>
    </div>
  );
}

export default GamePage;
